__turbopack_context__.v({
  "continueButton": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__continueButton",
  "infoContainer": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__infoContainer",
  "infoText": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__infoText",
  "row": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__row",
  "selected": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__selected",
  "selectedTimeSlot": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__selectedTimeSlot",
  "skeleton": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__skeleton",
  "timeSlotContainer": "BoxPickupScheduleOrderModalBody-module-scss-module__EtYwlG__timeSlotContainer",
});
